<header *ngIf="!param" class="header" id="home" data-stellar-background-ratio="0.5">
	<div class="color-overlay">
	  <nav class="navbar navbar-default navbar-fixed-top sticky-navbar" role="navigation">
	    <div class="container">
	      <div class="row">
	        <div class="section-header col-xs-5 col-md-6">
	          <div class="navbar-header"><a class="navbar-brand" href="./"><img src="./assets/img/logo-miles.svg" alt=""></a></div>
	        </div>
	      </div>
	    </div>
	  </nav>
	</div>
</header>
